<template>
	<span class="spclass">
				<b-modal id="showShareModal" hide-footer @hidden="resetSelectedItem" body-class="bodypaddingtop" no-close-on-backdrop>
				  <!-- <template #modal-title v-if="$root.share.link==''"> Selected Products <small class="font-weight-light">(Max 4 items)</small> </template> -->
				<template #modal-header>      		  
				  <h5 class="modal-title"> Selected Products <small class="font-weight-light">(Max 4 items)</small> </h5>			 
				  <button v-if="$root.share.link==''" type="button" aria-label="Close" @click="$bvModal.hide('showShareModal')" class="close">×</button>
				  <button v-else type="button" aria-label="Close" @click="$root.closeMeShareModel('showShareModal')" class="close">×</button>
				</template>
				  
				  <p class="m-1" v-if="$root.share.link!=''"><small>Shared link : </small><small class="font-weight-light">https://www.alluraa.com/share/{{$root.share.link}}</small></p>
				<b-container fluid class="p-1">					
				<!-- {{cartItems}} -->
			<!-- {{productAll}} -->
					<div class="card" :key="item.id" v-for="item in cartItems">
						<!-- <header class="card-header">featured</header> -->
						<div class="card-body">
							<b-row>
								<b-col cols="3"  sm="3" md="3" lg="3">
									<b-link :href="'/product/'+item.product_id"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
								</b-col>
								<b-col cols="7" sm="7" md="7" lg="7">
									<span class="pTitle">{{item.title}}</span>
									<ul class="p-0 m-0 shoppopup">
										<li v-if="item.short_description!=''"><small>{{item.short_description}}</small></li>
										<li>
											<small>Price: </small>
											<span v-if="item.special_price>0 && item.special_price!=null">
											 <del class="spCross"><small>{{$root.currency()+$root.tofixed((item.price ), 2)}}</small></del> <small class="my-0" >{{$root.currency()+$root.tofixed((item.special_price), 2)}}</small>
										   
											</span>
											<span v-else>
												<small class="my-0" >{{$root.currency()+$root.tofixed((item.price), 2)}}</small>
											</span>
										</li>
										<li ><small>Commission: </small> {{item.commission}}%</li>
										
										<li class="sharepopupStardiaplay"><product-rating :userrating="item.total_rating"></product-rating></li>
									</ul>
								</b-col>
								<b-col cols="1"  sm="1" md="1" lg="1">
									<b-link @click="$root.removeShareshop(item),productAll.push(item)" v-if="linkcreated==0"><i class="fa fa-trash" aria-hidden="true"></i></b-link>
									<!-- <b-link disabled v-else><i class="fa fa-trash" aria-hidden="true"></i></b-link> -->
								</b-col>
							</b-row>
							
						</div>
						
					</div>

				
				</b-container>
				<b-container fluid class="text-center" v-if="linkcreated==0">
					<span v-if="cartItems.length>=4"> <small class="maxPallow">Maximum 4 products allowed</small> </span>
					
					<span v-else-if="addItemmore==0 && cartItems.length<4"> 
					<b-button  variant="dark" pill class="mr-2" @click="addItemmore=1" v-if="productAll.length>0"><b-icon icon="plus"></b-icon> Add More</b-button>
					</span>
					<span v-else >						
						
						<span  v-if="cartItems.length==0" class="apinsharelist ">Please add product in share list </span>
						<small v-else class="maxPallow "><span class="blink_me">{{cartItems.length}} products added </span></small>
					</span>
					
					
					<b-button  v-if="cartItems.length>0" variant="dark" pill class="mr-2" @click="$root.shareProductShop(),linkcreated=1" ><i class="fa fa-share-alt mr-2 sharepopupName"></i> Share Now</b-button>
						
					
				</b-container> 
				
				  <b-container fluid class="p-1" v-if="linkcreated==1">
			  
				
					  <small>
					  <b-form-group label="Select Message" v-slot="{ ariaDescribedby }" class="mb-0 myoption">
					  <b-form-radio-group
						id="radio-slots"
						v-model="selected"
						:options="options"
						:aria-describedby="ariaDescribedby"
						name="radio-options-slots"				
						v-on:change="changeMessage"
					  >
					
					  </b-form-radio-group>
					</b-form-group>
					</small>
				<p class="m-0 text-center"><small class="noteMess font-weight-light">(Edit to send personalised messages)</small></p>
		<!--<div>Selectedd: {{selectedmess}}</div> -->
			  
			  
				  <div class="message-textarea-wrapper">
					<b-form-textarea v-model="linkComments"
					  id="message-textarea"
					  rows="3"
					  placeholder="Type your message here"
					></b-form-textarea>
				  </div>
				  <div
					class="product-share-wrapper d-flex justify-content-center align-items-ceter mt-3">
					<span class="product-share-txt align-self-center mr-4 sharepopupName">Share Now</span>
									<!--{{$root.share.link}}
									 {{linkComments}} -->
						<b-row class="float-right">
							<b-col class="socialIconAll"> 
								<!-- <div @click="shareSelectedProducts(item, 'sms')">
									<img src="../../assets/sms.svg" width="30px;" />
								</div> -->
								
								
								<div>
								<ShareNetwork
										network="email"
										:url="'https://www.alluraa.com/share/'+$root.share.link"
										title="Alluraa Products"
										:description="linkComments"
										hashtags="Alluraa"
										@open="$root.onShareClick($root.share.link,'email'),clerDData()">
										<img src="@/assets/sms.svg" width="30px;"/>
									</ShareNetwork>
								</div>
								<div>
									<ShareNetwork										
										network="facebook"
										:url="'https://www.alluraa.com/share/'+$root.share.link"
										title="Alluraa Products."
										:description="linkComments"
										hashtags="Alluraa"
										:quote="linkComments +' https://www.alluraa.com/share/'+$root.share.link"
										@open="$root.onShareClick($root.share.link,'Facebook'),clerDData()"
										>
										<img src="../../assets/facebook.svg" />
									</ShareNetwork>
								</div> 
								<div >
									<ShareNetwork										
										network="whatsapp"
										:url="'https://www.alluraa.com/share/'+$root.share.link"
										title="Alluraa Products"
										:description="linkComments +' https://www.alluraa.com/share/'+$root.share.link"
										@open="$root.onShareClick($root.share.link,'whatsapp'),clerDData()" >
										<img src="../../assets/whatsapp.svg" />
									</ShareNetwork>
								</div>
								<div >
									<ShareNetwork
										network="twitter"
										:url="'https://www.alluraa.com/share/'+$root.share.link"
										:title="'Alluraa Product. '+linkComments"
										hashtags="Alluraa"
										twitter-user=""
										:description="linkComments"
										@open="$root.onShareClick($root.share.link,'Twitter'),clerDData()">
										<img src="../../assets/twitter.svg" />
									</ShareNetwork>
								</div>
								<div >
									<ShareNetwork
										network="telegram"
										:url="'https://www.alluraa.com/share/'+$root.share.link"
										title="Alluraa Product."
										:description="linkComments"
										@open="$root.onShareClick($root.share.link,'Telegram'),clerDData()"
										>
										<img src="@/assets/telegram.svg" />
									</ShareNetwork>
								</div>
							</b-col>
						</b-row>

					
				  </div></b-container>
				  
				  <b-container  v-if="addItemmore==1 && linkcreated==0" class="mt-3 p-0 listproductpop">
						<!-- {{productAll}} -->
								<div class="el-table table-responsive table el-table--fit el-table--scrollable-Y el-table--enable-row-hover el-table--enable-row-transition b-table-sticky-header">
											<div class="hidden-columns"><div></div><div></div><div></div></div>
											<div class="el-table__header-wrapper">
												<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%;">
												<colgroup>
													<col name="el-table_2_column_5" :width="wr1">
													<col name="el-table_2_column_6" :width="wr2">
													<col name="el-table_2_column_7" :width="wr3">
													<!--<col name="el-table_2_column_7" width="20%">-->
													<col name="gutter" width="0"></colgroup>
														<thead class="has-gutter tblheader">
															<tr class="thead-light ">
															<th colspan="1" rowspan="1" class="el-table_2_column_5 is-leaf p-1"><div class="cell">Image</div></th>
															<th colspan="1" rowspan="1" class="el-table_2_column_6 is-leaf p-1"><div class="cell">Product details</div></th>
															<th colspan="1" rowspan="1" class="el-table_2_column_7 is-leaf p-1"><div class="cell">Action</div></th>
															
															</tr>
														</thead>
													</table>
												</div>
												<div class="el-table__body-wrapper is-scrolling-right">
												<table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
												<colgroup>
													<col name="el-table_2_column_x" width="wr1">
													<col name="el-table_2_column_y" width="wr2">
													<col name="el-table_2_column_z" width="wr3">
													<!-- <col name="el-table_2_column_8" width="20%">-->
												</colgroup> 
												<tbody>
													<tr class="el-table__row"  v-for="(item,index) in productAll" :key="item.id">
													<td rowspan="1" colspan="1" class="el-table_2_column_x  ">
														<b-img v-bind="thumbnailPropsList" rounded alt="" v-if="item.image==''" :src="$root.MEDIAPATH+'blank.jpg'">{{rowImage}}</b-img>
														<b-img-lazy v-bind="thumbnailPropsList" rounded alt="" v-else :src="$root.MEDIAAPI+'toolimage/get_image?size=120x120&src='+item.image">{{rowImage}}</b-img-lazy>
														
													</td>
													<td rowspan="1" colspan="1" class="el-table_2_column_y  ">
														<span class="pTitle">{{item.title}}</span>
													<ul class="p-0 d-block ">
															<li >{{'Seller : '+item.shopname}}</li>
															<li>{{'Brand : '+item.brand}}</li>
															<li>														
															{{'Commission : '+item.commission|0}}%														
															</li>
															<!--<li>
																<b-link class="create-list-cta d-flex align-items-center" v-b-modal="'create-list-modal'" @click="$root.updateShareshop(item),$root.sharepopup()" >
														<div class="icon-wrapper d-flex flex-column justify-content-center align-items-center mr-2"
														> <b-icon icon="plus"></b-icon>	</div><span>Create List</span> </b-link>
															</li> -->
														</ul>	
													
													</td>
													
													<td class="el-table_2_column_z  text-center">
													
														<!-- <b-button  pill variant="primary" class="mr-1 icon-btn"  size="sm" v-b-modal="'create-list-modal'" @click="$root.updateShareshop(item),$root.sharepopup(),productAll.splice(index, 1)" ><b-icon icon="check"></b-icon></b-button> -->
														
														<b-link class="addIconColor"  @click="$root.updateShareshop(item),$root.sharepopup(),productAll.splice(index, 1)" ><b-icon icon="plus-circle"></b-icon></b-link>
														<br/>
														<span><small>Add to List</small></span>
														
														
													</td>

													<!--<td rowspan="1" colspan="1" class="el-table_2_column_8"> {{$root.currency()+$root.tofixed(item.price,2)}}</td> -->
													</tr>
													
												<!----></tbody></table><!----><!----></div><!----><!----><!----><!---->
												<div class="el-table__column-resize-proxy" style="display: none;"></div>
												
											</div>

				  
				  </b-container>
				  
				  
				  
				  
				  
				</b-modal>

		</span>		
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
import ProductRating from "@/components/product-rating.vue";
export default {
  name: 'SharePopup',
  components: {
  //"cart-variant": CartVariant,
  "product-rating": ProductRating,
  },
  props: { 
	cartItems: { type: Array },
	cartData: { type: Array  },
	cartTotalqty:Number,
	productAll:{ type: Array  },
  },
  mounted(){
  
	if(window.innerWidth < 700){
		this.thumbnailPropsList= { blank: false, width: 60, height: 60, class: 'm1' };
		this.wr1='20%';
		this.wr2='75%';
		this.wr3='5%';
	}
  
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		linkcreated:0,
		linkComments:'',
		urlSavebank: this.$root.NEWAPIURL+'profileapi/save-bank',		
		thumbnailProps: { blank: false, width: 60, height: 60, class: 'm1' },
		 thumbnailPropsList: { blank: false, width: 120, height: 120, class: 'm1' },
		social_options: {
            'facebook': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'instagram': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'tweeter': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'whatsapp': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'telegram': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'sms': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
        },
		selectedmess:'',
		selected: 'whatsapp',
        options: [
          { text: 'Message 1', value: 'whatsapp' },
          { text: 'Message 2', value: 'facebook' },
          { text: 'Message 3', value: 'tweeter' },
          //{ text: 'Message 4', value: 'telegram' },
         // { text: 'Message 5', value: 'instagram' }
        ],
		wr1:'30%',
		wr2:'65%',
		wr3:'5%',
		addItemmore:0,
    }
  },
  methods:{
	inLodcard(){
			this.linkComments = this.social_options[this.$root.share.social];
		},
		changeMessage(arg){
		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },
		resetSelectedItem(){
		this.$root.share.link='';
		this.linkcreated=0;
		this.linkComments='';
		},
		clerDData(){
			console.log('cart Shop');
			this.cartItems=[];
			this.$root.share.shopshareitems=[];
			this.$root.share.shopshareitems.length=0;
			this.$root.share.link='';
			this.linkcreated=0;
			this.linkComments='';
			this.$bvModal.hide('showShareModal');
		
		}

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss">
.spCross{
font-size: 12px !important;
	color: darkgray;
	}
.spclass{
.spCross{
	font-size: 12px !important;
	color: darkgray;
	}
}

.shoppopup>li{
line-height:15px;
}
.card{
			margin-bottom: 12px;	
			box-shadow: 0px 0px 1px 0px #c6c6c6;
			
			.card-footer{
				background-color: #fff;
				border-top: 1px solid rgba(0,0,0,.125);
				.spCross{
					    font-size: 12px ;
   						color: darkgray;
				}
			}

			.card-body{
				padding: 5px;
				.pImg{
					max-height: max-content;
				}

				.pTitle{
					font-size: smaller;
					font-weight: 200;
					color: #3f414d;
				}
			}
		}
		.noteMess{
			font-size: 12px;
		}
.sharepopupStardiaplay{ width: 37%;height: 13px;}
	
	.addIconColor{
		color: #ff1f08;
		font-size: 16px;
	}
	
	.listproductpop{
		.tblheader{
			tr{
			 font-size:12px;
			 text-align: center;
				th{
					background: #eaeaea29;
					border-color: #dee2e645;
				}
			}
		}

		.pTitle{
			/* font-size: smaller; */
			font-weight: 500;
			color: #3f414d;
		}
		
	}
	.maxPallow{
		color:#ff1f08;
		margin-right: 9%;
		border: 1px solid #c6c6c6;
		padding: 6px;
		border-radius: 5px 5px;
		}
	.apinsharelist{
		color:#ff1f08;
	}
.blink_me {
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  20% {
    opacity: 0;
  }
}
</style>
